export default __webpack_public_path__ + "static/BioRhymeExpanded-ExtraBold-hint-all-c61a35607516827ac5c3c7c186c574bf.woff2";